import {
    ADMIN_UPDATE_STATIC_START,
    ADMIN_UPDATE_STATIC_SUCCESS,
    ADMIN_UPDATE_STATIC_ERROR
} from '../../constants';
import history from '../../history';
import { showToaster } from '../../helpers/toastrMessgaes/showToaster';
import { updateStaticPageMutation as mutation, getEditStaticPageQuery as query } from '../../lib/graphql';

export const updateStaticPage = (values) => {

    return async (dispatch, getState, { client }) => {
        try {
            let content = values?.content[0]?.content;

            dispatch({ type: ADMIN_UPDATE_STATIC_START });
            const { data } = await client.mutate({
                mutation,
                variables: {
                    content,
                    metaTitle: values?.metaTitle,
                    metaDescription: values?.metaDescription,
                    pageBanner: values?.pageBanner,
                    id: values?.id,
                    dynamicStaticContent: values?.content
                },
                refetchQueries: [{ query, variables: { id: values?.id } }]
            });

            if (data?.updateStaticPage?.status == 200) {
                showToaster({ messageId: 'changesUpdated', toasterType: 'success' });
                history.push('/siteadmin/staticpage/manage');
                dispatch({ type: ADMIN_UPDATE_STATIC_SUCCESS });
            }
            else {
                showToaster({ messageId: 'errorMessage', requestContent: { content: data?.updateStaticPage?.errorMessage }, toasterType: 'error' });
                dispatch({ type: ADMIN_UPDATE_STATIC_ERROR });
            }
        } catch (error) {
            showToaster({ messageId: 'catchMessage', requestContent: { content: error }, toasterType: 'error' });
            dispatch({ type: ADMIN_UPDATE_STATIC_ERROR });
            return false;
        }
        return true;
    };
}